import {
  GENERIC_MODAL_BACK_BUTTON,
  GENERIC_MODAL_SAVE_BUTTON,
} from '@commons/Modals/GenericModal/genericModalActions';

/**
 * Shared fullscreen GenericModal config for the catalog-step pickers (clone / manual add).
 * The hosted component reports its selection upward; the parent re-issues this config through
 * refreshGenericModal so the Save button's disabled state stays in sync with the selection.
 */
export const getCatalogPickerModal = ({
  title,
  icon,
  component,
  data,
  isConfirmDisabled,
  onCancel,
  onConfirm,
}) => ({
  type: 'actionWhite',
  isFullscreen: true,
  title,
  icon,
  customPadding: '24px 0px 0px 0px',
  handleCloseCleanUp: onCancel,
  component,
  data,
  actions: [
    {
      ...GENERIC_MODAL_BACK_BUTTON(),
      handleClick: onCancel,
    },
    {
      ...GENERIC_MODAL_SAVE_BUTTON(),
      isDisabled: isConfirmDisabled,
      handleClick: onConfirm,
    },
  ],
});
